/**
 * @fileoverview Agent definition for the chapter-extractor-chunked-v2 primitive.
 *
 * This agent is designed for processing large (epic-length) documents in chunks.
 * It takes a text chunk and previously extracted chapter summaries, then outputs
 * only the new, complete chapters found in this chunk.
 *
 * Key differences from chapter-extractor-v2:
 * - Accepts `textChunk` instead of `textInput`
 * - Accepts `previousChapters` for deduplication
 * - Accepts `chunkInfo` for context about position in document
 * - Only extracts complete chapters (ignores partial ones at boundaries)
 * - Prompt is optimized for incremental extraction behavior
 *
 * @category import.story.extraction.chunked
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'chapter-extractor-chunked-v2',
  kind: 'primitive',
  name: 'Chunked Chapter Extractor',
  description: 'Extracts chapters from a text chunk, skipping previously extracted chapters. Designed for processing epic-length documents.',
  category: 'import',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'import.story.extraction.chunked',
    usedBy: ['use-chapter-extractor-chunked-v2.ts'],
    relatedAgents: ['chapter-extractor-v2'],
  },
};
